import MoneyItem from "./MoneyItem.js";
import gameData from "../../gameData.js";

export default class Coin extends MoneyItem
{
    constructor(scene, x, y, coinData)
    {
        super(scene, x, y, coinData);

        let radius = 38;

        this.setInteractive(new Phaser.Geom.Circle(38, 38, radius), Phaser.Geom.Circle.Contains);
        this.scene.input.setDraggable(this);

        this.setBody({ type: 'circle' });

        this.setCollisionCategory(this.scene.noCollide_cat);
        this.setFrictionAir(.08);
        this.boundaryForce = .005;

        this.scene.addDelay(0, ()=>{
            this.shadow.anims.stop();
            this.anims.stop();
            this.setFrameIndex(0);
            this.shadow.setFrameIndex(0);
        });
    }

    draggingStarted()
    {
        this.scene.addTween(this, 150, {scaleX: this.scaleX * 1.2, scaleY: this.scaleY * 1.2, easeParams: [.8, .5]}, "Elastic");
        this.scene.addTween(this.shadow, 300, {xOffset: 6, yOffset: 6}, "Elastic");
        this.setCollisionGroup(this.scene.noCollide_group);
        this.setCollidesWith([]);
    }

    draggingStopped()
    {
        this.shadow.xOffset = this.shadow.yOffset = 3;
        this.setCollisionGroup([]);
        this.setCollidesWith([this.scene.noCollide_cat]);
    }
}